import { type MCPServerInfo } from '../../types';

const LaunchDarklyOfficialServer: MCPServerInfo = {
  serverId: 'LAUNCHDARKLY_OFFICIAL',
  name: 'LaunchDarkly',
  slug: 'launchdarkly-official',
  description:
    'Official LaunchDarkly hosted MCP server for managing feature flags, AgentControl configs, and observability. Uses OAuth — no API key required.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.launchdarkly.com/mcp/launchdarkly',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default LaunchDarklyOfficialServer;
